/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Rail_SectionsInputs */

const en_directory_detail_rail_sections = /** @type {(inputs: Directory_Detail_Rail_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On this page`)
};

const zh_directory_detail_rail_sections = /** @type {(inputs: Directory_Detail_Rail_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本页导航`)
};

/**
* | output |
* | --- |
* | "On this page" |
*
* @param {Directory_Detail_Rail_SectionsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_rail_sections = /** @type {((inputs?: Directory_Detail_Rail_SectionsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Rail_SectionsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_rail_sections(inputs)
	return zh_directory_detail_rail_sections(inputs)
});
export { directory_detail_rail_sections as "directory.detail.rail.sections" }